import { useRouteContext } from "@tanstack/react-router";

/** Indicates whether the current route is a V4 embed based on route context */
export const useIsEmbed = (): boolean => {
  try {
    // oxlint-disable-next-line react-hooks/rules-of-hooks
    return !!useRouteContext({ strict: false })?.isEmbed;
  } catch {
    return false;
  }
};
